module.exports = __webpack_public_path__ + "img/img_polaroid_quilt02@3x.fa7af5fc.png";